import React, { Component } from "react";
import { connect } from "react-redux";
import {} from "../../redux/app/actions";
import {} from "../../redux/csDsp/actions";
import {} from "../../redux/ui/actions";
import { addOutTimeTrAction, delOutTimeTrAction, updateOutTimeTrAction, changeOutTimeTrSelRowAction } from "../../redux/well/actions";
import Lgd, { probLgd } from "../common/Lgd";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        outTimeTrData: state.wellReducer.outTimeTrData,
        outTimeTrSelRow: state.wellReducer.outTimeTrSelRow,
    };
};

class OutTime extends Component {
    constructor(props) {
        super(props);
    }
    /*
     * 追加
     * @since ando 2023-8-10
     */
    addCat() {
        this.props.dispatch(addOutTimeTrAction(0));
    }
    /*
     * 行削除
     * @since ando 2024-03-27
     */
    deleteSel() {
        // 指定されたインデックスの行を除外して新しい wellsTrData 配列を作成する
        const updatedTrData1 = this.props.outTimeTrData.filter((el, i) => i != this.props.outTimeTrSelRow);

        const updatedTrData2 = updatedTrData1.map((el, i) => ({
            ...el,
        }));
        // 新しい wellsTrData をセット
        this.props.dispatch(updateOutTimeTrAction(updatedTrData2));
    }

    /*
     * テーブルクリック
     * @since ando 2024-07-29
     */
    changeRow = (e) => {
        e.target.closest("tbody").childNodes.forEach((el) => {
            el.classList.remove("selRow");
        });
        const tr = e.target.closest("tr");
        tr.classList.add("selRow");
        this.props.dispatch(changeOutTimeTrSelRowAction(tr.id));
        console.log(`Row ${tr.id} clicked!`);
    };

    /*
     * テーブルデータ書き換え
     * @since ando 2024-07-29
     */
    changeField = (e, index, field) => {
        // 例えば、選択された種別を取得する処理などを追加
        const changeField = e.target.value;
        if (isNaN(changeField)) {
            alert("数値を入力してください。");
            return;
        }
        const updatedTrData = this.props.outTimeTrData.map((el, i) => {
            if (i === index) {
                return { ...el, [field]: changeField };
            }
            return el;
        });
        // 新しい wellsTrData をセット
        this.props.dispatch(updateOutTimeTrAction(updatedTrData));
    };
    /*
     * テーブルデータ書き換え
     * @since ando 2024-07-29
     */
    changeFidddeld = (e, index, field) => {
        // 例えば、選択された種別を取得する処理などを追加
        const changeField = e.target.value;
        if (isNaN(changeField)) {
            alert("数値を入力してください。");
            return;
        }
        const updatedTrData = this.props.outTimeTrData.map((el, i) => {
            if (i === index) {
                return { ...el, [field]: changeField };
            }
            return el;
        });
        // 新しい wellsTrData をセット
        this.props.dispatch(updateOutTimeTrAction(updatedTrData));
    };

    render() {
        return (
            <div>
                <Sw title="出力時間" focusName="wells">
                    <div className="l-flex">
                        <button className="sBtn" onClick={() => this.addCat()}>
                            追加
                        </button>
                        <button className="sBtn" onClick={() => this.deleteSel()}>
                            削除
                        </button>
                    </div>
                    <div className="OutTimeInput l-mtSSS" style={{ overflowY: "scroll" }}>
                        <table className="idoTable">
                            <thead>
                                <tr>
                                    <th className="tsS">時間(d)</th>
                                </tr>
                            </thead>
                            <tbody ref={(ref) => (this.tbRef = ref)}>
                                {this.props.outTimeTrData.length !== 0 &&
                                    this.props.outTimeTrData.map((el, index) => (
                                        <tr id={index} key={index} onClick={(e) => this.changeRow(e, 0)}>
                                            <td>
                                                <input className="textTR" type="text" value={el.TIME} onChange={(e) => this.changeField(e, index, "TIME")} />
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </Sw>
            </div>
        );
    }
}

export default connect(mapStateToProps)(OutTime);
